import { removeLocalStorageItem } from "@/utils/common";

// Scope-relative rest paths (no leading slash) of pages that render the
// *current* organization and so stop existing in platform-only mode — the URL
// counterpart of `PLATFORM_ONLY_HIDDEN_NAV_ITEMS` in `useNavLinkItemFilter`.
const PLATFORM_ONLY_HIDDEN_REST_PATHS = ["entities/edit/current"];

// Where to land when platform-only mode invalidates the current page: the
// Entities list — an org-data list that stays available at platform scope.
export const PLATFORM_ONLY_FALLBACK_REST_PATH = "entities";

export const isRestPathHiddenInPlatformOnlyMode = (restPath: string): boolean =>
  PLATFORM_ONLY_HIDDEN_REST_PATHS.some(
    (hiddenPath) => restPath === hiddenPath || restPath.startsWith(`${hiddenPath}/`)
  );

export const clearCurrentOrganizationId = () => {
  removeLocalStorageItem("organizationId");
  // The platform-only flag is part of the same persisted scope choice — clear it
  // together with the org id so one user's platform-only mode can't leak into
  // the next login on this browser.
  removeLocalStorageItem("scopeIsPlatformOnly");
};
